define('drops/calendarTimeSlotItem/calendarTimeSlotItem',[
    'jquery',
    'underscore',
    'lq/drop',
    'lq/style',
    'lq/constants'
], function ($, _, Drop, Style, constants) {
    'use strict';

    var defaults = {
        data: {
            position: { x: 0, y: 0 },
            size: { x: 60, y: 30 }
        }
    };

    function CalendarTimeSlotItem(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        var self = this;

        this.$element
            .addClass('calendar-timeslot-item boxToBorderSize')
            .css({
                touchAction: 'auto'
            });

        this.addListener('ChildRendered', function (childDrop) {
            self.applyDataToChild(childDrop);
        });

        Style.renderStyles(this);
    }

    Drop.extend(CalendarTimeSlotItem, Drop);

    CalendarTimeSlotItem.typeName = 'CalendarTimeSlotItem';

    CalendarTimeSlotItem.prototype.preRender = function () {
        // no-op
    };

    CalendarTimeSlotItem.prototype.render = function ($element) {
        return this.createAndRenderDrops($element);
    };

    CalendarTimeSlotItem.prototype.postRender = function () {
        this.applyDataToChildren();
    };

    CalendarTimeSlotItem.prototype.applyDataToChild = function (childDrop) {
        childDrop.defaultEventArg = this.data.slotLabel;
    };

    CalendarTimeSlotItem.prototype.applyDataToChildren = function () {
        var row = this.data.slotRow || {};
        var outputs = this.data.slotOutputs || {};
        var self = this;

        var applyToDrop = function (drop) {
            if (drop.setValue && drop.data && drop.data.name && _.has(row, drop.data.name)) {
                var outputType = outputs[drop.data.name] || constants.valueTypes.string;
                drop.setValue({
                    type: outputType,
                    value: row[drop.data.name]
                });
            }
            drop.informListeners('DatasourceApplied', {
                slotStartMinute: self.data.slotStartMinute,
                slotEndMinute: self.data.slotEndMinute,
                slotLabel: self.data.slotLabel
            });
            _.each(drop.pool || [], applyToDrop);
        };
        _.each(this.pool, applyToDrop);
    };

    CalendarTimeSlotItem.prototype.applyPosition = function () {
        var w = this.data.size && this.data.size.x != null ? this.data.size.x : 30;
        var h = this.data.size && this.data.size.y != null ? this.data.size.y : 30;
        this.$element.css({
            width: w + 'px',
            height: h + 'px'
        });
    };

    return CalendarTimeSlotItem;
});

